module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAhElEQVR42u3aoQ2AUBBEwV8ABo8m1EBjvwlqo6VFEAQ17FzyktOjTtxIMpobAAAAAAAAAAAAAACUA9zrnqYAAAAAAAAAAAAAAAAA4KttAPwAlu1KUwAAAAAAAAAAAACcwgDe5ZxHmgIAAAAAAAAAAAAAAAAAj5IAAAAAAAAAAAAAAPT1AE3nSIJpiVX3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Gambia.png
// module id = q6/r
// module chunks = 0 62 63